import { makeStyles } from '@mui/styles';
import { defaultIcon } from './default';

const useStyles = makeStyles((theme) => ({
  iconWrapper: {
    position: 'relative',
    display: 'inline-block',
    width: '1em',
    height: '1em',
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    overflow: 'hidden',
  },
  icon: {
    height: ({ bold }: any = theme) => (bold ? '.125em' : '.1em'),
    maxHeight: ({ bold }: any = theme) => (bold ? '.125em' : '.1em'),
    ...defaultIcon,
  },
}));

export default useStyles;
